import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { FaCheck, FaTimes } from "react-icons/fa"
import { formatCurrency } from "../../../utils/formatCurrency"

function ConfirmNegotiateDialog({negotiateInfo,close,accept,reject}){

    const footer= (
        <div className="flex justify-center w-full gap-3">
            <div className="grid w-1/3">
                <Button 
                label='Negociar'
                icon={<FaCheck/>}
                severity="success"
                onClick={()=>accept()}
                />
            </div>
            <div className="grid w-1/3">
                <Button 
                label="Voltar"
                icon={<FaTimes/>}
                severity="danger"
                onClick={()=>reject(0)}
                />
            </div>
        </div>  
    )

    return(
        <Dialog
        visible
        onHide={()=>close()}
        pt={{
            root: 'w-screen md:w-[50vw] lg:w-[30vw] h-auto',
            headerTitle: 'font-bold text-xl w-full text-center',
          }}
        header="Confirmação"
        footer={footer}
        >
            <div className="text-center grid gap-6">
                <h4 className="text-xl"><b>Confirme os dados da negociação a ser gerada</b></h4>
                <div className="text-xl">
                    <h5><b>Valor Total:</b> {formatCurrency(negotiateInfo.valorTotal)}</h5>
                    <h5><b>Valor Desconto:</b> {formatCurrency(negotiateInfo.desconto)}</h5>
                    <h5><b>Valor c/ Desconto:</b> {formatCurrency(negotiateInfo.valorAPagar)}</h5>
                    <h5><b>Valor Direto:</b> {formatCurrency(negotiateInfo.valorPague)}</h5>
                    <h5><b>Valor a Receber:</b> {formatCurrency(negotiateInfo.valorProvider)}</h5>
                </div>
            </div>
        </Dialog>
    )
}

export default ConfirmNegotiateDialog